var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-tryagain","title":"ส่งข้อมูลผิดพลาด","ok-only":""}},[_c('p',{staticClass:"my-2"},[_vm._v("กรุณาลองใหม่อีกครั้ง")])])
}
var staticRenderFns = []

export { render, staticRenderFns }